
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[uid]",
      function () {
        return require("private-next-pages/series/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[uid]"])
      });
    }
  